import { useBalanceOfUser } from 'hooks/vvs-miner-mole/useMoleContract'
import { isEcoFarmSupported, isFarmBoostingSupported } from 'utils/isNftStakingSupported'
import { useGetEcoFarmNftCollections } from 'views/Farms/hooks/useGetEcoFarmNftCollections'

const useNftBalanceOfUser = (farmId: number) => {
  const isFarmBoost = isFarmBoostingSupported(farmId)
  const isEcoFarm = isEcoFarmSupported(farmId)

  // Miner Mole
  const { data: farmBoostNftBalanceOfUser, isLoading: isFarmBoostNftBalanceOfUserLoading } = useBalanceOfUser({
    enabled: isFarmBoost,
  })

  //
  const { data: userNftCollections, isLoading: isUserNftCollectionsLoading } = useGetEcoFarmNftCollections(farmId, {
    enabled: isEcoFarm,
  })
  const nftBalanceOfUser = userNftCollections?.totalCount

  let initInfoData = {
    isLoading: true,
    data: 0,
  }

  if (isFarmBoost) {
    initInfoData = {
      ...initInfoData,
      data: farmBoostNftBalanceOfUser,
      isLoading: isFarmBoostNftBalanceOfUserLoading,
    }
  }

  if (isEcoFarm) {
    initInfoData = {
      ...initInfoData,
      data: nftBalanceOfUser,
      isLoading: isUserNftCollectionsLoading,
    }
  }

  return initInfoData
}

export default useNftBalanceOfUser
